import Fetch from '@/utils/Fetch';

type LogLevel = 'information' | 'warning' | 'debug';

const log = async (message: string, level: LogLevel = 'information'): Promise<void> => {
    try {
        await Fetch.post({
            url: '/Logging',
            params: { message: `[webapp] v${__APP_VERSION__} ${message}`, level },
        });
    } catch {
        // fire-and-forget — never let logging errors surface to the user
    }
};

const logClientCrash = async (error: unknown, componentStack?: string): Promise<void> => {
    const parts: string[] = [];

    if (error instanceof Error) {
        parts.push(`${error.name}: ${error.message}`);
        if (error.stack) parts.push(`\nStack: ${error.stack}`);
    } else {
        parts.push(String(error));
    }

    if (componentStack) parts.push(`\nComponent stack: ${componentStack}`);

    await log(parts.join(''), 'warning');
};

export default { log, logClientCrash };
